export default {"src":"/_next/static/media/GPRO.63347fb7.svg","height":18,"width":18};